import React, { useEffect, useState } from 'react';
import { UserService } from '../../services/UserService';
import Overview from './overview';
import Subscription from './subscription';
import CompanyInfo from './company-Info';
import PaymentMethod from './payment-method';
import chargebeeService from '../../services/chargebee.service';
import { OrganizationService } from '../../services/OrganizationService';
import { MapToOrgAccountBilling, OrgAccountBilling } from '../../models/organization.model';
import OrgPlanHistoryComponent from '../new-Organizations/planHistory';
import * as selector from "../../selectors/selectors";
import { useSelector } from 'react-redux';
import { setHeaderTitle } from '../../helpers/header.helper';
import { pageTitles } from '../shared/constants';

const AccountBilling = () => {
    const IsDarkMode: boolean = useSelector(selector.isDarkMode);

    const [option, setOption] = useState<number>(0);
    const [accountBillingData, setAccountBillingData] = useState<OrgAccountBilling>();
    const [paymentMethodDetails, setPaymentMethodDetails] = useState([]);

    const handleChange = (index) => {
        setOption(index)
    }
    const tabOptions = [
        { Label: 'Overview', Component: <Overview AccountBillingData={accountBillingData} PaymentMethodDetails={paymentMethodDetails} /> },
        { Label: 'Subscription', Component: <Subscription AccountBillingData={accountBillingData} PaymentMethodDetails={paymentMethodDetails} InvoiceOnClick={handleChange} /> },
        { Label: 'Seat History', Component: <div className='w-p-96 my-2 br-2 bg-color-secondary h-p-90 mx-auto'><OrgPlanHistoryComponent /></div> },
        // { Label: 'Company Info', Component: <CompanyInfo /> },
        // { Label: 'Payment Method', Component: <PaymentMethod ActivePaymentMethodDetails={paymentMethodDetails} PrimaryPaymentMethodDetails={() => primaryPaymentMethodDetails()} /> },
    ];


    const primaryPaymentMethodDetails = () => {
        let data = { "organization_id": UserService.getCurrentUserFromLocalStorage().OrgId }
        chargebeeService.getCardDeatils(data).then((res) => {
            setPaymentMethodDetails(res.data.card)
        })
    }

    useEffect(() => {
        primaryPaymentMethodDetails()
        OrganizationService.GetNewOrganizationAccountDetails().then((res) => {
            setAccountBillingData(MapToOrgAccountBilling(res.data))
        }).catch((err) => { })

        setHeaderTitle(pageTitles.ACCOUNT_BILLING)
        return setHeaderTitle
    }, [])

    return (<div className={`h-p-98 d-flex w-p-98 br-3 mx-auto flex-direction ${IsDarkMode ? "bg-color-primary-background" : "bg-color-account-billing-background"} `}>
        <div className='w-p-96 mx-auto mt-2'>
            <div className='d-flex w-p-100 bb-primary-divider-4'>
                {tabOptions.map((tab, index) => (
                    <div className='w-20 c-pointer' onClick={() => handleChange(index)}>
                        <div className='h4-regular color-account-billing-text-gray justify-center d-flex '
                        >{tab.Label}</div>
                        {option === index && <div className='show-conversation-animation  show-conversation-border show-conversation-height bg-color-primary-light'></div>}
                    </div>
                ))}
            </div>
        </div>

        {tabOptions[option]?.Component}

    </div>
    );
};

export default AccountBilling;
